/**
 * access controlled storage
 *
 * A  storage is a space of URIs in which you can individually control for each resource
 *     who has access to it.
 *
 *
 * http://www.w3.org/ns/pim/space#ControlledStorage
 */
var ControlledStorage = 'http://www.w3.org/ns/pim/space#ControlledStorage';
/**
 * personal storage
 *
 * A personal storage is a space of URIs in which you and only you have access to data,
 *     you cannot give access to anyone else.
 *
 *
 * http://www.w3.org/ns/pim/space#PersonalStorage
 */
var PersonalStorage = 'http://www.w3.org/ns/pim/space#PersonalStorage';
/**
 * public storage
 *
 * A public storage is a space of URIs in which you have access to data,
 *     and all data is accessible to anyone without control.
 *
 *
 * http://www.w3.org/ns/pim/space#PublicStorage
 */
var PublicStorage = 'http://www.w3.org/ns/pim/space#PublicStorage';
/**
 * storage
 *
 * A storage is a space of URIs in which you have access to data.
 *
 *
 * http://www.w3.org/ns/pim/space#Storage
 */
var Storage = 'http://www.w3.org/ns/pim/space#Storage';
/**
 * workspace
 *
 * Workspaces are place where data is stored, and associated polices of privacy.
 * A given application typically stores information in several different
 * workspaces, some being user private, some shared, and some public.
 *
 *
 * http://www.w3.org/ns/pim/space#Workspace
 */
var Workspace = 'http://www.w3.org/ns/pim/space#Workspace';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/pim/space#masterWorkspace
 */
var masterWorkspace = 'http://www.w3.org/ns/pim/space#masterWorkspace';
/**
 * preferences file
 *
 *
 *
 * http://www.w3.org/ns/pim/space#preferencesFile
 */
var preferencesFile = 'http://www.w3.org/ns/pim/space#preferencesFile';
/**
 * storage
 *
 * The storage in which this workspace is, or the storage which
 * contains this resource, or a storage available to this agent to use.
 *
 * http://www.w3.org/ns/pim/space#storage
 */
var storage = 'http://www.w3.org/ns/pim/space#storage';
/**
 * URI prefix
 *
 * URIs which start with this string are in this workspace or storage.
 * This may be used for constructing URIs for new storage resources.
 *
 *
 * http://www.w3.org/ns/pim/space#uriPrefix
 */
var uriPrefix = 'http://www.w3.org/ns/pim/space#uriPrefix';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/pim/space#workspace
 */
var workspace = 'http://www.w3.org/ns/pim/space#workspace';

var spaceImport = /*#__PURE__*/Object.freeze({
	ControlledStorage: ControlledStorage,
	PersonalStorage: PersonalStorage,
	PublicStorage: PublicStorage,
	Storage: Storage,
	Workspace: Workspace,
	masterWorkspace: masterWorkspace,
	preferencesFile: preferencesFile,
	storage: storage,
	uriPrefix: uriPrefix,
	workspace: workspace
});

export { ControlledStorage as C, PersonalStorage as P, Storage as S, Workspace as W, PublicStorage as a, spaceImport as b, masterWorkspace as m, preferencesFile as p, storage as s, uriPrefix as u, workspace as w };
